import { render, staticRenderFns } from "./RelationDropdown.vue?vue&type=template&id=1d8ead48&scoped=true&"
import script from "./RelationDropdown.vue?vue&type=script&lang=ts&"
export * from "./RelationDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./RelationDropdown.vue?vue&type=style&index=0&id=1d8ead48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8ead48",
  null
  
)

export default component.exports